import React, { FC, useState } from "react";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "../../../../../Api/Model/LocationDto.csharp";
import { CollapsibleContainer } from "../../../Helpers/CollapsibleContainer";

type DoctorCardProps = {
  doctor: DoctorDto;
  centers: LocationDto[];
};

export const DoctorCard: FC<DoctorCardProps> = ({ doctor, centers }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { name, pictureUrl, bio, jobTitle, centers: doctorCenters } = doctor;

  const supportedCenters = centers.filter((center) =>
    doctorCenters.includes(center.id)
  );
  const [bioFirstPart, ...bioRest] = (bio ?? "")
    .split("</p>")
    .filter((p) => !!p);

  return (
    <div className="edge-to-edge-sm">
      <div className="card card-wings-sm">
        <div className="card-body px-2 px-sm-0 py-sm-3 fs-5">
          <div className="d-flex mb-3">
            <img
              className="circular-image medium me-2"
              src={pictureUrl + "?width=216&height=216&rmode=crop&ranchor=top"}
              alt=""
            />
            <div>
              <h4 className="h5">{name}</h4>
              <p className="fw-bold mb-1">{jobTitle}</p>
              {supportedCenters.map((center) => (
                <p className="mb-0" key={center.id}>
                  {center.name}
                </p>
              ))}
            </div>
          </div>

          {bioFirstPart && (
            <div
              className="doctor-card-preview"
              dangerouslySetInnerHTML={{ __html: bioFirstPart + "</p>" }}
            />
          )}
          {!!bioRest?.length && (
            <CollapsibleContainer
              content={
                bioRest.filter((part) => part.length != 0).join("</p>") + "</p>"
              }
              id="doctor-card"
            />
          )}
        </div>
      </div>
    </div>
  );
};
